<template>
  <router-view />
</template>
<script>
export default {
  name: "workbench",
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.workbench {
  position: relative;
}
</style>
